import React, { useEffect, useState } from 'react';
import { Eye, EyeOff, Shield, User, Lock } from 'lucide-react';
import { auth, firestore } from '../firebase.config';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  sendPasswordResetEmail, 
  updatePassword, 
  reauthenticateWithCredential, 
  EmailAuthProvider, 
  getAuth
} from 'firebase/auth';
import { doc, setDoc, getDoc, updateDoc, getFirestore } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { actionType } from '../context/Reducer';
import { useStateValue } from '../context/StateProvider';

const AdminLogin = () => {
      const [{ admin }, dispatch] = useStateValue();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(''); 
  const navigate = useNavigate();
  useEffect(() => {
    // Check for cached admin data on component mount
    const cachedAdmin = localStorage.getItem('admin');
    if (cachedAdmin) {
      const adminData = JSON.parse(cachedAdmin);
      dispatch({
        type: actionType.SET_ADMIN,
        admin: adminData,
      });
      navigate('/createItem');
    }
  }, [dispatch, navigate]); // Add dispatch and navigate to the dependency array

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
        const firestore = getFirestore();
        const userDocRef = doc(firestore, 'Admin', username.trim());
        const userDoc = await getDoc(userDocRef);

        if (!userDoc.exists()) {
            setError('Invalid username or admin does not exist.');
            return;
        }

        const userData = userDoc.data();
        const { email } = userData;

        const auth = getAuth();
        await signInWithEmailAndPassword(auth, email, password);

        toast.success('Sign In successful!', {
            position: 'top-right',
            autoClose: 3000,
        });

        // **Dispatch action to update user state**
        dispatch({
            type: actionType.SET_ADMIN,
            admin: userData, // Dispatch the user data
        });

        localStorage.setItem('admin', JSON.stringify(userData));

        // Navigate to job-search only on successful login and user existence
        navigate('/createItem');
    } catch (error) {
        console.error('Login Error:', error);
        let errorMessage = 'An error occurred during login.';

        if (error.code === 'auth/wrong-password') {
            errorMessage = 'Incorrect password.';
        } else if (error.code === 'auth/user-not-found') {
            errorMessage = 'User not found.';
        }

        setError(errorMessage);
    } finally {
        setLoading(false);
    }
};
// const handleRegister = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         const userId = userCredential.user.uid;

//         await setDoc(doc(firestore, 'Admin', username.trim()), {
//             username,
//             email,
//             password, 
//             userId,
//         });
//         toast.success('Registration successful! Please sign in.', {
//             position: 'top-right',
//             autoClose: 3000,
//           });
//         setIsRegistering(false);
//         setError('');
//         setUsername('');
//         setEmail('');
//         setPassword('');
//     } catch (error) {
//         setError(error.message);
//     } finally {
//         setLoading(false);
//     }
// };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userDocRef = doc(firestore, 'Admin', username.trim());
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        setError('Admin not found.');
        setLoading(false);
        return;
      }

      const userData = userDoc.data();
      const { email } = userData;

      await sendPasswordResetEmail(auth, email);
      alert('Password reset email sent! Check your inbox.');

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f5f5]  flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            {/* {isRegistering ? 'Register ' : 'Sign In'} */}
            Sign In
          </h2>
          <p className="text-gray-600">
            {/* {isRegistering ? 'Create an user account' : 'Sign in with Correct credentials'} */}
            Sign in with Correct credentials
          </p>
        </div>

        <form 
   //  onSubmit={isResettingPassword ? handleForgotPassword : (isRegistering ? handleRegister : handleLogin)}
         onSubmit={isResettingPassword ? handleForgotPassword :  handleLogin}

          className="space-y-6"
        >
          {error && <div className="bg-red-50 text-red-500 p-3 rounded-lg text-sm">{error}</div>}

          {/* Username Field */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 block">Username</label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                placeholder="Enter your username"
                required
              />
            </div>
          </div>
{/* 
           {isRegistering && (
            <>
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">Email</label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-3 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>
         
          </>
          )}  */}

          {!isResettingPassword && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">New Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-12 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                  placeholder="Enter your new password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                </button>
              </div>
            </div>
          )}

           {/* Current Password Field (for re-authentication) */}
          {/* {isResettingPassword && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 block">Current Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                  placeholder="Enter current password"
                  required
                />
              </div>
            </div>
          )}  */}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0e55a8] hover:bg-[#0e55a8] text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {/* {loading ? 'Processing...' : isResettingPassword ? 'Reset Password' : (isRegistering ? 'Register' : 'Sign In')} */}
            {loading ? 'Processing...' : 'Sign In'}
        
          </button>

        

          {/* {isResettingPassword && (
            <div className="text-center mt-4">
              <button
                type="button"
                className="text-[#0e55a8] font-semibold hover:underline"
                onClick={() => setIsResettingPassword(false)}
              >
                Back to Login
              </button>
            </div>
          )}
  {!isRegistering && !isResettingPassword && (
            <div className="text-center mt-2">
              <button
                type="button"
                className="text-[#0e55a8] font-semibold hover:underline"
                onClick={() => setIsResettingPassword(true)}
              >
                Forgot Password?
              </button>
            </div>
          )}
         {!isResettingPassword && (
            <div className="text-center mt-4">
              <button
                type="button"
                className="text-[#0e55a8] font-semibold hover:underline"
                onClick={() => setIsRegistering(!isRegistering)}
              >
                {isRegistering ? 'Already have an account? Sign In' : 'Need an account? Register'}
              </button>
            </div>
          )}  */}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;

